import NavbarNotAuth from '../userNotAuth/components/navbarNotAuth'
import { Link, useNavigate, useLocation } from 'react-router-dom'
import { useState, useRef, useEffect } from "react"
import axios from 'axios'
import DivBottom from '../userNotAuth/components/divBottom'

function ReimpostaPassword() {
    const navigate = useNavigate()
    const location = useLocation()
    const [rndCode, setRndCode] = useState()
    const [formData, setFormData] = useState({
        password: '',
        ripetiPass: null,
        email: null,
        rndCodeFromInput: null
    })
    const [msg, setMsg] = useState({
        password: null,
        codeFailed: null
    })

    const successDom = useRef()
    const bannerChangePass = useRef()
    const bannerRndCode = useRef()

    function handleChange(e) {
        setMsg({ password: null, codeFailed: false })
        const { name, value, type, checked } = e.target//attributi degli input
        let inputValue = type === "checkbox" ? checked : value//se type = checkbox inputValue = true altrimenti inputValue = value         
        if (name === 'rndCodeFromInput') {
            if (isNaN(inputValue)) { //inputValue not a number or empty
                document.getElementById("rndCode").value = ''
                return
            }
        }
        setFormData({ ...formData, [name]: inputValue })//valorizzo il name del nuovo oggetto formData 
    }
    function handleForm2(e) {//ACCETTAZIONE PASSWORD
        e.preventDefault()
        const specialChars = /[`!@#$%^&*()_\-+=\[\]{};':"\\|,.<>\/?~ ]/
        if (formData.password !== "" && formData.ripetiPass !== formData.password) {
            setMsg({ password: "Password diverse" }); return
        }
        if (formData.password.length < 8) {
            setMsg({ password: 'Min 8 caratteri' }); return
        }
        if (/[A-Z]/.test(formData.password) === false) {
            setMsg({ password: 'Deve contenere una maiuscola' }); return
        }
        if (specialChars.test(formData.password) === false) {
            setMsg({ password: 'Deve contenere un carattere speciale' }); return
        }
        axios.post('/reimpostaPassword', formData).then(res => {
            if (res.data === 'Success') {
                bannerChangePass.current.style.opacity = '0'
                successDom.current.style.left = '2%'
                localStorage.clear()
            }
        })
    }
    function handleForm1(e) {//ACCETTAZIONE rndCode
        e.preventDefault()
        if (rndCode !== parseInt(formData.rndCodeFromInput)) {
            setMsg({ codeFailed: true })
        }
        else {
            bannerChangePass.current.style.display = 'block'
            bannerRndCode.current.style.display = 'none'
        }
    }
    useEffect(() => {
        if (localStorage.getItem('previousPage') !== '/login') {
            navigate('/', { replace: true })
        } else {
            setFormData({ ...formData, email: location.state.emailForConfirm })
            setRndCode(location.state.rndCode)
            localStorage.removeItem('previousPage')
        }
    }, [])
    return (<>
        <NavbarNotAuth />
        <div className='container'>
            <h2 style={{ marginTop: '5rem' }}><b>Reimpostazione password</b></h2><hr />
            {rndCode &&
                <div><br />
                    <div ref={bannerRndCode} style={{ marginBottom: '6rem' }}>
                        <h5>Inserisci il codice numerico che hai ricevuto via email.</h5>
                        <br />
                        <form onSubmit={handleForm1}>
                            <input onChange={handleChange} id="rndCode" style={{
                                fontWeight: '600', fontSize: 'large', textAlign: 'center'
                            }}
                                type='text'
                                name='rndCodeFromInput'
                                required
                                placeholder='*****'
                                minLength={5}
                                maxLength={5} />
                            {msg.codeFailed && <p style={{ color: 'red' }}>
                                <i>Codice errato...riprova.</i></p>}<br />
                            <div className='mt-5'>
                                <button className='btn btn-secondary' type='submit'>INVIA</button>
                            </div>
                        </form>
                    </div>

                    <form onSubmit={handleForm2}>
                        <div className="col-md-6 mt-5" ref={bannerChangePass}
                            style={{ display: 'none' }}>
                            <label htmlFor="password">Nuova Password <p><i>(min 8, una maiuscola, un carattere speciale)</i></p></label>
                            <input
                                className="form-control"
                                type="text" required
                                name="password"
                                onChange={handleChange}
                            />
                            <label htmlFor="confPassword">Ripeti password:</label>
                            <input
                                className="form-control"
                                name="ripetiPass"
                                onChange={handleChange}
                                type="text" required
                            />
                            <div style={{ color: 'red' }}>
                                {msg.password}
                            </div>
                            <button className='btn btn-primary mt-4' type="submit">Procedi</button>
                        </div>
                    </form>
                </div>}
            {!rndCode &&
                <h2 style={{ marginBottom: '15rem', marginTop: '4rem' }}>Sessione scaduta</h2>
            }
        </div>

        {/* --------- BANNER DI SUCCESSO DEL CAMBIO PASSWORD ----------- */}
        <div ref={successDom} style={{
            left: '-100rem', transition: '.3s', position: 'absolute', top: '7rem',
            width: '100%', padding: '1rem'
        }}>
            <br /><br />
            <h1 className='mt-3' style={{
                margin: '0 auto',
                backgroundColor: 'white',
                borderRadius: '20px',
                border: '1px solid black',
                padding: '10px',
                width: 'fit-content'
            }}>ZONA EVENTI
            </h1><br />
            <h3 className='mt-4'>Password modificata.</h3>
            <h5 style={{ marginTop: '1rem' }}>
                La tua password è stata modificata con successo.<br /> 
                Per i prossimi accessi inserisci la tua nuova password.
            </h5><br />
            <Link to={{ pathname: '/login' }}>
                <button className='btn btn-primary'>Login</button>
            </Link>
        </div><br /><br />
        <div style={{ marginTop: '27px' }}>
            <DivBottom />
        </div>
    </>)
}
export default ReimpostaPassword